import { useEffect } from 'react';

import { type Whoami } from '@/types/whoami';
import {
  clearSentryUser,
  setSentryFeatureFlags,
  setSentryUser,
} from '@/utils/sentry-user';

/**
 * Keep the Sentry scope in step with who is signed in.
 *
 * An effect rather than a one-shot call at boot: account switching and
 * impersonation both replace the identity without remounting the tree, and a
 * stale id would credit the wrong person with the next error.
 */
export function useSentryIdentify(whoami: Whoami | undefined | null): void {
  useEffect(() => {
    if (!whoami?.external_id) {
      clearSentryUser();
      return;
    }

    setSentryUser({
      external_id: whoami.external_id,
      account_id: whoami.account_id,
      role: whoami.role,
      is_impersonating: whoami.is_impersonating,
    });
    setSentryFeatureFlags(whoami.feature_flags);
  }, [whoami]);
}
